<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isEditModeUpdate">
            {{ contentsCategoryName }}更新
          </template>
          <template v-else>{{ contentsCategoryName }}登録</template>
        </h2>
        <div
          v-if="errorMessage"
          class="error-message"
          style="white-space: pre-wrap"
        >
          {{ errorMessage }}
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 12%"></th>
              <th style="width: 30%"></th>
              <th style="width: 10%"></th>
              <th style="width: 10%"></th>
              <th style="width: 10%"></th>
              <th style="width: 24%"></th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                表示期間
              </td>
              <td>
                <input
                  type="date"
                  id="txtDispDtFrom"
                  class="form-control"
                  ref="txtDispDtFrom"
                  v-model="PopupData.keisaiKikanStart"
                  :max="AppConstants.MAX_DATE_VALUE"
                />
                <label style="margin: 0rem 0.2rem">～</label>
                <input
                  type="date"
                  id="txtDispDtFrom"
                  class="form-control"
                  v-model="PopupData.keisaiKikanEnd"
                  :max="AppConstants.MAX_DATE_VALUE"
                />
              </td>
            </tr>
            <tr>
              <td class="form-control-title">
                <label class="required-mark">※</label>
                タイトル
              </td>
              <td>
                <input
                  type="text"
                  id="txtTitle"
                  maxlength="255"
                  class="form-control"
                  v-model="PopupData.title"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <div class="form-inline flex-container">
          <div class="form-group" style="width: 35%; margin-right: 1rem">
            <fieldset>
              <legend>表示対象</legend>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAll"
                  name="hyojiTaisho"
                  :value="LoginPopupRegConstants.HYOJI_TAISHO_ALL"
                  class="form-check-input"
                  v-model="PopupData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAll" class="form-check-label">全員</label>
              </div>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAgSegment"
                  name="hyojiTaisho"
                  :value="LoginPopupRegConstants.HYOJI_TAISHO_AG_SEGMENT"
                  class="form-check-input"
                  v-model="PopupData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAgSegment" class="form-check-label">
                  エージェントセグメント
                </label>
              </div>
              <div class="form-group">
                <select
                  id="cmbAgSegment"
                  class="form-control"
                  v-model="PopupData.agSegmentId"
                  v-bind:disabled="!isHyojiTaishoAgSegment"
                >
                  <option></option>
                  <option
                    v-for="item in agSegmentList"
                    :key="item.agSegmentCode"
                    :value="item.agSegmentCode"
                  >
                    {{ item.agSegmentCode }}：{{ item.agSegmentName }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAg"
                  name="hyojiTaisho"
                  :value="LoginPopupRegConstants.HYOJI_TAISHO_AG_CODE"
                  class="form-check-input"
                  v-model="PopupData.hyojiTaisho"
                  v-on:change="onChangeHyojiTaisho"
                />
                <label for="rdoAg" class="form-check-label">
                  個別エージェント
                </label>
              </div>
              <div class="form-group">
                <label>AGコード</label>
                <input
                  type="text"
                  id="txtAgCode"
                  maxlength="8"
                  class="form-control"
                  v-model="PopupData.agCode"
                  v-bind:disabled="
                    !isHyojiTaishoAgCode || PopupData.agCodeList.length > 0
                  "
                />
              </div>
              <div class="form-group">
                <div class="file-upload">
                  <button
                    :class="[
                      'btn',
                      'btn-sm',
                      isHyojiTaishoAgCode ? 'btn-primary' : 'btn-secondary',
                    ]"
                    @click="onAgCodeFileUpload"
                    v-bind:disabled="!isHyojiTaishoAgCode"
                  >
                    アップロード
                  </button>
                  <input
                    type="file"
                    :accept="hyojiTaishoExtensions.join(',')"
                    @change="handleAgCodeFileUpload"
                    v-bind:disabled="!isHyojiTaishoAgCode"
                    ref="agCodeFileInput"
                    style="display: none"
                  />
                </div>
                <label
                  style="margin-left: 1rem"
                  v-show="PopupData.agCodeList.length > 0"
                >
                  {{ getValueAgCodeUploadCnt }}
                </label>
              </div>
            </fieldset>
          </div>
          <div class="form-group" style="width: 65%; min-height: 210px">
            <label class="required-mark">※</label>
            <label>本文</label>
            <QuillEditor
              id="rtxtHonbun"
              @update:content="handleContentUpdate"
              v-model="PopupData.contentsBody"
              style="height: 210px"
            />
          </div>
        </div>
        <div class="form-inline flex-container">
          <div>
            <table>
              <thead>
                <tr>
                  <th style="width: 20%"></th>
                  <th style="width: 3%"></th>
                  <th style="width: 25%"></th>
                  <th style="width: 14%"></th>
                  <th style="width: 3%"></th>
                  <th style="width: 45%"></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in PopupData.contentsLinkList"
                  :key="item.rowNo"
                >
                  <td v-if="index == 0" class="form-control-title">
                    リンクキャプション
                  </td>
                  <td v-else></td>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input
                      type="text"
                      maxlength="255"
                      class="form-control"
                      v-model="item.caption"
                    />
                  </td>
                  <td v-if="index == 0" class="form-control-title">
                    リンクURL
                  </td>
                  <td v-else></td>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input
                      type="text"
                      maxlength="255"
                      class="form-control"
                      v-model="item.url"
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <table>
              <thead>
                <tr>
                  <th style="width: 20%"></th>
                  <th style="width: 3%"></th>
                  <th style="width: 27%"></th>
                  <th style="width: 10%"></th>
                  <th style="width: 40%"></th>
                </tr>
              </thead>
              <tbody>
                <!-- 添付ファイル -->
                <tr>
                  <td
                    :class="[
                      'form-control-title',
                      { 'vertical-align-top': hasContentsTempFile },
                    ]"
                  >
                    添付ファイル
                  </td>
                  <td colspan="4">
                    <div class="file-upload">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="
                          onContentsFileUpload(
                            LoginPopupRegConstants.TRIGGER_TEMP_FILE
                          )
                        "
                      >
                        +
                      </button>
                      <input
                        type="file"
                        :accept="tempFileExtensions.join(',')"
                        @change="handleContentsFileSelected"
                        ref="tempFileInput"
                        style="display: none"
                      />
                    </div>
                    <div
                      v-for="item in PopupData.contentsTempFileList"
                      :key="item.rowNo"
                    >
                      <button
                        class="btn btn-danger btn-sm"
                        @click="
                          onRemoveContentsFile(
                            item.rowNo,
                            LoginPopupRegConstants.TRIGGER_TEMP_FILE
                          )
                        "
                      >
                        -
                      </button>
                      {{ item.fileName }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="form-control-title">添付ファイル説明</td>
                  <td colspan="5">
                    <input
                      type="text"
                      maxlength="255"
                      class="form-control"
                      v-model="PopupData.contentsTempFileExp"
                      v-bind:disabled="!hasContentsTempFile"
                    />
                  </td>
                </tr>
                <!-- 画像ファイル -->
                <tr>
                  <td
                    :class="[
                      'form-control-title',
                      { 'vertical-align-top': hasContentsImgFile },
                    ]"
                  >
                    画像ファイル
                  </td>
                  <td colspan="4">
                    <div class="file-upload">
                      <button
                        class="btn btn-primary btn-sm"
                        @click="
                          onContentsFileUpload(
                            LoginPopupRegConstants.TRIGGER_IMG_FILE
                          )
                        "
                      >
                        +
                      </button>
                      <input
                        type="file"
                        :accept="imgFileExtensions.join(',')"
                        @change="handleContentsFileSelected"
                        ref="imgFileInput"
                        style="display: none"
                      />
                    </div>
                    <div
                      v-for="item in PopupData.contentsImgList"
                      :key="item.rowNo"
                    >
                      <button
                        class="btn btn-danger btn-sm"
                        @click="
                          onRemoveContentsFile(
                            item.rowNo,
                            LoginPopupRegConstants.TRIGGER_IMG_FILE
                          )
                        "
                      >
                        -
                      </button>
                      {{ item.fileName }}
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="form-control-title">画像ファイル説明</td>
                  <td colspan="4">
                    <input
                      type="text"
                      maxlength="255"
                      class="form-control"
                      v-model="PopupData.contentsImgFileExp"
                      v-bind:disabled="!hasContentsImgFile"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group" style="width: 40%; margin-left: 1rem">
            <fieldset style="height: 96%; padding: 1rem">
              <label>チェックパターン</label>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAll"
                  name="checkPatarn"
                  :value="LoginPopupRegConstants.CHECK_PATARN_JIKAI"
                  class="form-check-input"
                  v-model="PopupData.checkPatern"
                /><label class="checklabel">次回以降表示しない</label>
                <input
                  type="radio"
                  id="rdoAll"
                  name="checkPatarn"
                  :value="LoginPopupRegConstants.CHECK_PATARN_KAKUNIN"
                  class="form-check-input"
                  v-model="PopupData.checkPatern"
                /><label class="checklabel">確認した</label>
              </div>
              <label>ポップアップ表示対象</label>
              <div class="form-group">
                <input
                  type="radio"
                  id="rdoAll"
                  name="checkDsipTarget"
                  :value="LoginPopupRegConstants.CHECK_DISP_TARGET_ALL"
                  class="form-check-input"
                  v-model="PopupData.checkDispTarget"
                /><label class="checklabel">全員</label>
                <input
                  type="radio"
                  id="rdoAll"
                  name="checkDsipTarget"
                  :value="LoginPopupRegConstants.CHECK_DISP_TARGET_KANNRI"
                  class="form-check-input"
                  v-model="PopupData.checkDispTarget"
                /><label class="checklabel">管理者のみの表示可能</label>
              </div>
            </fieldset>
          </div>
        </div>
        <table>
          <thead>
            <th style="width: 30%"></th>
            <th style="width: 40%"></th>
            <th style="width: 30%"></th>
          </thead>
          <tbody>
            <td colspan="3" style="text-align: right; margin-top: 1rem">
              <button
                type="button"
                name="btnBack"
                class="btn btn-footer btn-primary"
                @click="onBack"
              >
                戻る
              </button>
            </td>
            <td>
              <button
                type="button"
                name="btnFixed"
                class="btn btn-footer btn-primary"
                @click="onFixed"
              >
                <template v-if="isEditModeUpdate">更新</template>
                <template v-else>登録</template>
              </button>
            </td>
          </tbody>
        </table>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType, computed } from "vue";
import * as tus from "tus-js-client"; // * as tus を使ってインポート
import messages from "@/assets/messages.json";
import {
  formatMessage,
  sanitizeInput,
  hasNoGaiji,
  scrollToTop,
  checkFileName,
  isTokenAlive,
  outputDebugLogs,
  commonHandleAxiosError,
  replaceInlineStyleWithClass,
  addInlineStyleToClass,
} from "@/Common";
import { format } from "date-fns";
import { useRouter } from "vue-router";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import apiAuthClient from "@/util/apiClientAuth";
import { AppConstants } from "@/constants/AppConstants";
import { AxiosResponse } from "axios";
import QuillEditor from "../controls/QuillEditor.vue";
import { goBackToPreviousUrl } from "@/router";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";

interface LoginPopupRegParam {
  categoryId: string;
  contentsId: string;
  processingMode: string;
}

interface AgSegment {
  agSegmentCode: string;
  agSegmentName: string;
}

interface LoginPopupRegData {
  contentsId: string; // コンテンツID
  title: string; // タイトル
  contentsBody: string; // 本文
  keisaiKikanStart: string; // 掲載期間FROM
  keisaiKikanEnd: string; // 掲載期間TO
  hyojiTaisho: string; // 表示対象
  agSegmentId: string; // エージェントセグメント
  agCode: string; // AGコード
  agCodeList: string[]; // AGコードリスト
  contentsLinkList: ContentsLink[]; // コンテンツリンクリスト
  contentsTempFileList: ContentsFile[]; // 添付ファイルリスト
  contentsImgList: ContentsFile[]; // 画像ファイルリスト
  contentsTempFileExp: string; // 添付ファイル説明
  contentsImgFileExp: string; // 画像ファイル説明
  checkPatern: string; //チェックパターン
  checkDispTarget: string; //チェック表示対象
}

// コンテンツリンクのinterface
interface ContentsLink {
  rowNo: number;
  caption: string;
  url: string;
}

// 添付ファイルのinterface
interface ContentsFile {
  rowNo: number;
  fileName: string;
  file: File | null;
  fileUrl: string | null;
  isUpload: boolean;
}

//
interface InitialDisplayData {
  agSegmentList: AgSegment[];
  keisaiKikanStart: string;
  keisaiKikanEnd: string;
  maxFileSize: string;
}

class LoginPopupRegConstants {
  // API-URL
  static readonly API_URL_INITIAL_DISPLAY =
    "/api/LoginPopupReg/GetInitialDisplayData";
  static readonly API_URL_GET_POPUP_DATA = "/api/LoginPopupReg/GetPopupData";
  static readonly API_URL_REG_POPUP_DATA = "/api/LoginPopupReg/RegPopupData";
  static readonly API_URL_UPDATE_POPUP_DATA =
    "/api/LoginPopupReg/UpdatePopupData";

  // 表示対象
  static readonly HYOJI_TAISHO_ALL = "0"; // ALL
  static readonly HYOJI_TAISHO_AG_SEGMENT = "1"; // AGセグメント
  static readonly HYOJI_TAISHO_AG_CODE = "2"; // AGコード

  // イベント発火元
  static readonly TRIGGER_TEMP_FILE = "tempFile"; // 添付ファイル
  static readonly TRIGGER_IMG_FILE = "imgFile"; // 画像ファイル

  // チェックパターン
  static readonly CHECK_PATARN_JIKAI = "1"; // 次回以降表示しない
  static readonly CHECK_PATARN_KAKUNIN = "2"; // 確認した

  // チェック表示対象
  static readonly CHECK_DISP_TARGET_ALL = "1"; // 全員
  static readonly CHECK_DISP_TARGET_KANNRI = "2"; // 管理者のみ
}

export default defineComponent({
  name: "LoginPopupRegComponent",
  props: {
    categoryId: {
      type: String as PropType<string>,
    },
    contentsId: {
      type: String as PropType<string>,
    },
    editMode: {
      type: String as PropType<string>,
    },
  },
  components: {
    HeaderComponent,
    FooterComponent,
    QuillEditor,
    BackToTop,
  },
  setup() {
    const router = useRouter();
    const contentsCategoryId = ref(""); // ローカルストレージ．コンテンツカテゴリID
    const contentsId = ref(""); // ローカルストレージ．コンテンツID
    const processingMode = ref(""); // ローカルストレージ．編集モード
    const { getCategoryNeme, getCategoryURL } = useUserParmitionStore();
    const processingStore = useProcessingStore();
    const errorMessage = ref(""); // エラーメッセージ
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const categoryId = ref<string | null>(null);
    const contentsCategoryName = ref<string | null>(null); // コンテンツカテゴリ名
    const agSegmentList = ref<AgSegment[]>([]); // AGセグメントリスト
    const isInitComplete = ref(false); // 初期表示完了フラグ
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const isContentsDeleted = ref(false); // コンテンツ削除フラグ
    const { logoutUser } = useUserStore();

    // コンテンツデータ
    const PopupData = ref<LoginPopupRegData>({
      contentsId: "", // コンテンツID
      title: "", // タイトル
      contentsBody: AppConstants.QuillEditor_EMPTY, // 本文
      keisaiKikanStart: "", // 掲載期間FROM
      keisaiKikanEnd: "", // 掲載期間TO
      hyojiTaisho: LoginPopupRegConstants.HYOJI_TAISHO_ALL, // 表示対象
      agSegmentId: "", // エージェントセグメント
      agCode: "", // AGコード
      agCodeList: [], // AGコードリスト
      contentsLinkList: [
        { rowNo: 1, caption: "", url: "" },
        { rowNo: 2, caption: "", url: "" },
        { rowNo: 3, caption: "", url: "" },
      ], // コンテンツリンクリスト
      contentsTempFileList: [], // 添付ファイルリスト
      contentsImgList: [], // 画像ファイルリスト
      contentsTempFileExp: "", // 添付ファイル説明
      contentsImgFileExp: "", // 画像ファイル説明
      checkPatern: LoginPopupRegConstants.CHECK_PATARN_JIKAI, // チェックパターン
      checkDispTarget: LoginPopupRegConstants.CHECK_DISP_TARGET_ALL, // チェック表示対象
    });

    // アップロード
    const hyojiTaishoExtensions = [".csv"]; // 表示対象の拡張子
    const tempFileExtensions = [".pdf", ".docx", ".xlsx", ".txt", ".pptx"]; // 添付ファイルの拡張子
    const imgFileExtensions = [".jpg", ".png"]; // 画像ファイルの拡張子
    const uploadProgress = ref<number | null>(null); //
    let maxFileSize = 0; // ファイルアップロードの最大サイズ

    // 本文update処理
    const handleContentUpdate = (newContent: string) => {
      PopupData.value.contentsBody = newContent;
    };

    const txtDispDtFrom = ref<HTMLSelectElement | null>(null);
    const agCodeFileInput = ref<HTMLInputElement | null>(null);

    const initialDisplayData = ref<InitialDisplayData>({
      agSegmentList: [],
      keisaiKikanStart: "",
      keisaiKikanEnd: "",
      maxFileSize: "",
    });

    // アップロード関連
    const tempFileInput = ref<HTMLInputElement | null>(null);
    const imgFileInput = ref<HTMLInputElement | null>(null);
    let uploadTarget = ref("");

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // sessionStorageからパラメータ取得
        const sessionParam = sessionStorage.getItem(
          AppConstants.LOGIN_POPUP_REG_SESSION_NAME
        );
        if (sessionParam) {
          // 存在する場合はパラメータを変数にセット
          const loginPopupRegParam = JSON.parse(
            sessionParam
          ) as LoginPopupRegParam;
          categoryId.value = loginPopupRegParam.categoryId;
          contentsId.value = loginPopupRegParam.contentsId;
          processingMode.value = loginPopupRegParam.processingMode;

          // sessionStorageからパラメータ削除
          sessionStorage.removeItem(AppConstants.LOGIN_POPUP_REG_SESSION_NAME);
        } else {
          // 存在しない場合はエラー
          errorMessage.value = messages.ERR_SYS998;
          return;
        }

        //コンテンツカテゴリ名取得
        contentsCategoryName.value = getCategoryNeme(categoryId.value);

        // ログインポップアップ通知登録初期表示データ取得
        const response = await apiAuthClient.post(
          LoginPopupRegConstants.API_URL_INITIAL_DISPLAY,
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            categoryId: categoryId.value, // カテゴリID
            contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
          }
        );

        // 初期表示情報取得
        initialDisplayData.value = response.data.initialDisplayData;

        // エージェントセグメントコンボボックス設定
        agSegmentList.value = initialDisplayData.value.agSegmentList;

        // 掲載期間FROM
        PopupData.value.keisaiKikanStart = formatDate(
          initialDisplayData.value.keisaiKikanStart
        );

        // 掲載期間TO
        PopupData.value.keisaiKikanEnd = formatDate(
          initialDisplayData.value.keisaiKikanEnd
        );

        // ファイルアップロードの最大サイズ
        maxFileSize = parseInt(initialDisplayData.value.maxFileSize || "0", 10);

        // 編集モードが更新の場合
        if (isEditModeUpdate.value) {
          // コンテンツデータ取得
          const response = await apiAuthClient.post(
            LoginPopupRegConstants.API_URL_GET_POPUP_DATA,
            {
              systemKbn: process.env.VUE_APP_SYSTEM_KBN,
              agCode: agCode.value,
              userId: userId.value,
              categoryId: categoryId.value, // カテゴリID
              contentsId: contentsId.value, // コンテンツID
              contentsCategoryId: categoryId.value, // コンテンツカテゴリID
            }
          );

          console.log(response);
          // レスポンス設定
          setResponseOutput(response);
        }

        // フォーカス設定
        if (txtDispDtFrom.value) {
          txtDispDtFrom.value.focus();
        }

        // スクロールを上部に移動
        scrollToTop();

        isInitError.value = false;
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }

      isInitComplete.value = true;
    });

    /**
     * ログインポップアップ通知データ取得APIのレスポンス処理
     * @param response
     */
    const setResponseOutput = (response: AxiosResponse) => {
      const LoginPopup = response.data.loginPopupData;

      // レスポンスの日付フォーマット
      LoginPopup.keisaiKikanStart = formatDate(LoginPopup.keisaiKikanStart); // 掲載期間FROM
      LoginPopup.keisaiKikanEnd = formatDate(LoginPopup.keisaiKikanEnd); // 掲載期間TO

      // CSP対応によるunsafe-inlineの制限によって、style属性が含まれていると
      // エラーになるため、サーバーから送信される本文データの色の部分はclass属性になっている。
      // quillエディタで文字色を表示するために、class属性にstyle属性も追加している
      LoginPopup.contentsBody = addInlineStyleToClass(LoginPopup.contentsBody);

      // 表示対象コードリストを退避
      const hyojiTaishoCodeList = LoginPopup.hyojiTaishoCodeList;
      // 表示対象コードリストを削除
      delete LoginPopup.hyojiTaishoCodeList;

      // レスポンス設定
      PopupData.value = LoginPopup as LoginPopupRegData;

      // 表示対象を復元
      PopupData.value.agSegmentId = "";
      PopupData.value.agCode = "";
      PopupData.value.agCodeList = [];
      if (isHyojiTaishoAgSegment.value) {
        // AGセグメント
        PopupData.value.agSegmentId = hyojiTaishoCodeList[0];
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード
        if (hyojiTaishoCodeList.length > 1) {
          PopupData.value.agCodeList = hyojiTaishoCodeList;
        } else {
          PopupData.value.agCode = hyojiTaishoCodeList[0];
        }
      }
    };

    /**
     * 戻るボタン押下
     */
    const onBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      if (isContentsDeleted.value) {
        // コンテンツを削除している場合
        // カテゴリIDからURLを取得して一覧に戻る
        const backUrl = getCategoryURL(contentsCategoryId.value);
        outputDebugLogs("【 contentsCategoryId 】:" + contentsCategoryId.value);
        outputDebugLogs("【 backUrl 】:" + backUrl);

        if (backUrl) {
          router.push(backUrl);
        } else {
          // カテゴリIDからURLが取得できなかった場合は共通の戻る処理
          goBackToPreviousUrl();
        }
      } else {
        // 上記以外
        goBackToPreviousUrl();
      }
    };

    /**
     * 登録ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      // 入力チェック
      if (!validateInput()) {
        scrollToTop();
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(
          messages.CNF_0001,
          "データ",
          isEditModeUpdate.value ? "更新" : "登録"
        )
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        let result = false;

        // ファイルアップロード
        // 添付ファイル
        result = await executeContentsFiles(
          PopupData.value.contentsTempFileList
        );

        if (result) {
          // 画像ファイル
          result = await executeContentsFiles(PopupData.value.contentsImgList);
        }

        // ファイルアップロードに失敗している場合
        if (!result) {
          scrollToTop();
          errorMessage.value = formatMessage(
            messages.ERR_SYS003,
            "ファイルアップロード"
          );
          return;
        }

        if (result) {
          if (isEditModeUpdate.value) {
            // 更新処理
            await executeUpdate();
          } else {
            // 登録処理
            await executeCreate();
          }
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * ファイルアップロード実行
     * @param contentsFileList
     */
    async function executeContentsFiles(contentsFileList: ContentsFile[]) {
      let result = true;

      for (const contentsFile of contentsFileList) {
        if (contentsFile.isUpload) {
          try {
            await uploadContentsFile(contentsFile);
          } catch (error) {
            result = false;
            break;
          }
        }
      }

      return result;
    }

    /**
     * 登録処理
     */
    const executeCreate = async () => {
      try {
        // ログイン後ポップアップ通知データ登録APIを実行
        const response = await apiAuthClient.post(
          LoginPopupRegConstants.API_URL_REG_POPUP_DATA,
          getRequestInput()
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "登録"));

        // 編集モードを設定
        processingMode.value = AppConstants.CONTENTS_EDIT_MODE_UPDATE;
        // コンテンツIDを設定
        contentsId.value = response.data.contentsId;
        // コンテンツデータ再取得
        await getContents();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 更新処理
     */
    const executeUpdate = async () => {
      try {
        // ログイン後ポップアップ通知データ更新APIを実行
        await apiAuthClient.post(
          LoginPopupRegConstants.API_URL_UPDATE_POPUP_DATA,
          getRequestInput()
        );

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "更新"));

        // コンテンツデータ再取得
        await getContents();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * コンテンツデータ取得
     */
    const getContents = async () => {
      // コンテンツデータ取得
      isInitComplete.value = false;

      const response = await apiAuthClient.post(
        LoginPopupRegConstants.API_URL_GET_POPUP_DATA,
        {
          systemKbn: process.env.VUE_APP_SYSTEM_KBN,
          agCode: agCode.value,
          userId: userId.value,
          categoryId: categoryId.value, // カテゴリID
          contentsId: contentsId.value,
          contentsCategoryId: categoryId.value, // コンテンツカテゴリID
        }
      );

      // レスポンス設定
      setResponseOutput(response);

      // フォーカス設定
      if (txtDispDtFrom.value) {
        txtDispDtFrom.value.focus();
      }

      // スクロールを上部に移動
      scrollToTop();

      isInitComplete.value = true;
    };

    /**
     * 登録・更新APIのリクエストデータを返却します。
     */
    const getRequestInput = (): object => {
      return {
        systemKbn: process.env.VUE_APP_SYSTEM_KBN,
        agCode: agCode.value,
        userId: userId.value,
        categoryId: categoryId.value, // カテゴリID
        contentsId: PopupData.value.contentsId, // コンテンツID
        contentsCategoryId: contentsCategoryId.value, // コンテンツカテゴリID
        title: sanitizeInput(PopupData.value.title), // タイトル
        // CSP対応によるunsafe-inlineの制限によって、style属性が含まれていると
        // エラーになるため、サーバーに送る前にstyle属性をclassに変換している
        contentsBody: replaceInlineStyleWithClass(
          sanitizeInput(PopupData.value.contentsBody)
        ), // 本文
        //contentsBody: sanitizeInput(PopupData.value.contentsBody), // 本文
        keisaiKikanStart: getValidStrDate(PopupData.value.keisaiKikanStart), // 掲載期間FROM
        keisaiKikanEnd: getValidStrDate(PopupData.value.keisaiKikanEnd), // 掲載期間TO
        hyojiTaisho: PopupData.value.hyojiTaisho, // 表示対象
        hyojiTaishoCodeList: getHyojiTaishoCodeList(), // 表示対象コードリスト
        contentsLinkList: PopupData.value.contentsLinkList.map(
          (contentsLink) => ({
            rowNo: contentsLink.rowNo,
            caption: sanitizeInput(contentsLink.caption),
            url: sanitizeInput(contentsLink.url),
          })
        ), // コンテンツリンクリスト
        contentsTempFileList: PopupData.value.contentsTempFileList, // 添付ファイルリスト
        contentsImgList: PopupData.value.contentsImgList, // 画像ファイルリスト
        contentsTempFileExp: sanitizeInput(PopupData.value.contentsTempFileExp), // 添付ファイル説明
        contentsImgFileExp: sanitizeInput(PopupData.value.contentsImgFileExp), // 画像ファイル説明
        checkPatern: PopupData.value.checkPatern, // チェックパターン
        checkDispTarget: PopupData.value.checkDispTarget, // チェック表示対象
      };
    };

    /**
     * 表示対象コードリストを返却します。
     */
    const getHyojiTaishoCodeList = (): string[] => {
      // 表示対象
      if (isHyojiTaishoAgSegment.value) {
        // AGセグメント
        return [PopupData.value.agSegmentId];
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード
        if (PopupData.value.agCodeList.length > 0) {
          // アップロードされている場合
          return PopupData.value.agCodeList.map((agCode) =>
            sanitizeInput(agCode)
          );
        } else {
          // テキスト入力されている場合
          return [sanitizeInput(PopupData.value.agCode)];
        }
      }

      return [];
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 掲載期間
      const keisaiKikanStart = PopupData.value.keisaiKikanStart;
      const keisaiKikanEnd = PopupData.value.keisaiKikanEnd;

      // 必須チェック
      if (!keisaiKikanStart) {
        messageList.value.push(
          formatMessage(messages.ERR_0001, "表示期間FROM")
        );
      }
      if (!keisaiKikanEnd) {
        messageList.value.push(formatMessage(messages.ERR_0001, "表示期間TO"));
      }
      // 大小チェック
      if (keisaiKikanStart && keisaiKikanEnd) {
        if (new Date(keisaiKikanStart) > new Date(keisaiKikanEnd)) {
          messageList.value.push(
            formatMessage(messages.ERR_0005, "表示期間FROM", "表示期間TO")
          );
        }
      }

      // タイトル
      const sanitizedTitle = sanitizeInput(PopupData.value.title);
      // 必須チェック、使用不可文字チェック
      if (!sanitizedTitle) {
        messageList.value.push(formatMessage(messages.ERR_0001, "タイトル"));
      } else if (!hasNoGaiji(sanitizedTitle)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "タイトル"));
      }

      if (isHyojiTaishoAgSegment.value) {
        // エージェントセグメント

        // 必須チェック
        if (!PopupData.value.agSegmentId) {
          messageList.value.push(
            formatMessage(messages.ERR_0003, "エージェントセグメント")
          );
        }
      } else if (isHyojiTaishoAgCode.value) {
        // AGコード

        // 必須チェック、使用不可文字チェック
        if (!PopupData.value.agCode && PopupData.value.agCodeList.length == 0) {
          messageList.value.push(formatMessage(messages.ERR_0002, "AGコード"));
        } else if (PopupData.value.agCodeList.length > 0) {
          // アップロードされている場合
          if (
            PopupData.value.agCodeList.some((agCode) => {
              const sanitizedAgCode = sanitizeInput(agCode);
              return !hasNoGaiji(sanitizedAgCode);
            })
          ) {
            messageList.value.push(
              formatMessage(messages.ERR_0026, "AGコード")
            );
          }
        } else {
          // テキスト入力されている場合
          const sanitizedAgCode = sanitizeInput(PopupData.value.agCode);
          if (!hasNoGaiji(sanitizedAgCode)) {
            messageList.value.push(
              formatMessage(messages.ERR_0026, "AGコード")
            );
          }
        }
      }

      // 本文
      const sanitizeBody = sanitizeInput(PopupData.value.contentsBody);
      // 必須チェック、使用不可文字チェック
      if (
        !sanitizeBody ||
        PopupData.value.contentsBody == AppConstants.QuillEditor_EMPTY
      ) {
        messageList.value.push(formatMessage(messages.ERR_0001, "本文"));
      } else if (!hasNoGaiji(sanitizeBody)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "本文"));
      }

      // リンクキャプション、リンクURL
      PopupData.value.contentsLinkList.forEach((contentsLink, index) => {
        const num = index + 1;
        const sanitizedCaption = sanitizeInput(contentsLink.caption);
        const sanitizedUrl = sanitizeInput(contentsLink.url);

        // リンクキャプション
        // 使用不可文字チェック
        if (!hasNoGaiji(sanitizedCaption)) {
          messageList.value.push(
            formatMessage(messages.ERR_0026, "リンクキャプション" + num)
          );
        }

        // リンクURL
        // 入力チェック、使用不可文字チェック
        if (sanitizedCaption && !sanitizedUrl) {
          messageList.value.push(
            formatMessage(messages.ERR_0002, "リンクURL" + num)
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(messages.ERR_0026, "リンクURL" + num)
          );
        }
      });

      // 添付ファイル
      PopupData.value.contentsTempFileList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            LoginPopupRegConstants.TRIGGER_TEMP_FILE
          );
        });

      // 画像ファイル
      PopupData.value.contentsImgList
        .filter((contentsFile) => contentsFile.file != null)
        .forEach((contentsFile) => {
          // ファイルチェック
          validateContentsFile(
            messageList.value,
            contentsFile,
            LoginPopupRegConstants.TRIGGER_IMG_FILE
          );
        });

      // 添付ファイル説明
      const sanitizedContentsTempFileExp = sanitizeInput(
        PopupData.value.contentsTempFileExp
      );
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedContentsTempFileExp)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "添付ファイル説明")
        );
      }

      // 画像ファイル説明
      const sanitizedContentsImgFileExp = sanitizeInput(
        PopupData.value.contentsImgFileExp
      );
      // 使用不可文字チェック
      if (!hasNoGaiji(sanitizedContentsImgFileExp)) {
        messageList.value.push(
          formatMessage(messages.ERR_0026, "画像ファイル説明")
        );
      }

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * ファイルチェック
     * @param contentsFile
     */
    const validateContentsFile = (
      messageList: string[],
      contentsFile: ContentsFile,
      trigger: string
    ): boolean => {
      let isErr = false;

      // ファイルサイズチェック
      if (!isFileSize(contentsFile.file)) {
        messageList.push(
          (errorMessage.value = formatMessage(
            messages.ERR_0024,
            maxFileSize / (1024 * 1024)
          ))
        );
        isErr = true;
      }

      // イベントの発火元により処理を分岐
      switch (trigger) {
        case LoginPopupRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル

          if (!isFileExtensions(contentsFile.file, ...tempFileExtensions)) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "添付ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(
              contentsFile,
              PopupData.value.contentsTempFileList
            )
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "添付ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "添付ファイル名"
              ))
            );
            isErr = false;
          }
          break;
        case LoginPopupRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル

          // 拡張子チェック
          if (!isFileExtensions(contentsFile.file, ...imgFileExtensions)) {
            // 拡張子チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0027,
                "画像ファイル"
              ))
            );
            isErr = false;
          } else if (
            !isFilenameDuplicate(contentsFile, PopupData.value.contentsImgList)
          ) {
            // ファイル名重複チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0017,
                "画像ファイル名"
              ))
            );
            isErr = false;
          } else if (!checkFileName(contentsFile.fileName.toLowerCase())) {
            // ファイル名チェック
            messageList.push(
              (errorMessage.value = formatMessage(
                messages.ERR_0025,
                "画像ファイル名"
              ))
            );
            isErr = false;
          }
          break;
      }
      return !isErr;
    };

    /**
     * ファイルサイズチェック
     */
    const isFileSize = (file: File | null): boolean => {
      return (file?.size ?? 0) <= maxFileSize;
    };

    /**
     * ファイル拡張子チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFileExtensions = (
      file: File | null,
      ...extensions: string[]
    ): boolean => {
      return extensions.some((extension) =>
        file?.name.toLowerCase().endsWith(extension)
      );
    };

    /**
     * ファイル名重複チェック
     * @param file ファイル
     * @param extensions 拡張子
     */
    const isFilenameDuplicate = (
      target: ContentsFile,
      contentsListFile: ContentsFile[]
    ): boolean => {
      return !contentsListFile
        .filter((contentsFile) => contentsFile.rowNo != target.rowNo)
        .some((contentsFile) => contentsFile.fileName == target.fileName);
    };

    /**
     * ファイルアップロード処理
     * @param item
     */
    const uploadContentsFile = (contentsFile: ContentsFile): Promise<void> => {
      return new Promise((resolve, reject) => {
        if (!contentsFile.file) {
          reject("No file selected");
          return;
        }

        // ローカルストレージからトークンを取得
        const token = localStorage.getItem(AppConstants.TOKEN_SESSION_NAME);
        if (!token) {
          reject("No token found. Please log in.");
          return;
        }

        const upload = new tus.Upload(contentsFile.file, {
          // ファイルアップロードのエンドポイント
          endpoint: process.env.VUE_APP_FILE_UPLOAD_ENDPOINT,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          metadata: {
            filename: contentsFile.file.name,
            filetype: contentsFile.file.type,
            agcode: agCode.value,
            userid: userId.value,
          },
          onError: (error) => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.error("Upload failed:", error);
            }
            reject(error);
          },
          onProgress: (bytesUploaded, bytesTotal) => {
            uploadProgress.value = Math.floor(
              (bytesUploaded / bytesTotal) * 100
            );
          },
          onSuccess: () => {
            if (process.env.VUE_APP_DEBUG === "true") {
              console.log("Upload finished:", upload.url);
            }
            // ファイルURLを保存
            contentsFile.fileUrl = upload.url;
            resolve();
          },
        });

        upload.start();
      });
    };

    /**
     * 表示対象ラジオ変更時
     */
    const onChangeHyojiTaisho = () => {
      PopupData.value.agSegmentId = "";
      PopupData.value.agCode = "";
      PopupData.value.agCodeList = [];
    };

    /**
     * アップロードボタン押下時
     */
    const onAgCodeFileUpload = () => {
      // ファイル選択イベント発火
      if (agCodeFileInput.value) {
        agCodeFileInput.value.click();
      }
    };

    /**
     * 表示対象アップロード時
     */
    const handleAgCodeFileUpload = (event: Event) => {
      if (processingStore.isProcessing) {
        return;
      }

      // メッセージクリア
      errorMessage.value = "";
      PopupData.value.agCode = "";
      PopupData.value.agCodeList = [];
      // 処理中フラグON
      processingStore.isProcessing = true;
      //
      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          //拡張子のチェック
          if (!isFileExtensions(file, ...hyojiTaishoExtensions)) {
            errorMessage.value = formatMessage(messages.ERR_0010);
            scrollToTop();
            return;
          }

          // ファイル名のチェック
          if (!checkFileName(file.name.toLowerCase())) {
            errorMessage.value = formatMessage(messages.ERR_0025, "ファイル名");
            scrollToTop();
            return;
          }

          // ファイルの内容を読み込み、行数をチェック
          const reader = new FileReader();
          reader.onload = () => {
            const text = reader.result as string;
            const lines = text.split(/\r\n|\n/);
            // 行数が0件かどうかをチェック
            if (lines.length === 0 || (lines.length === 1 && lines[0] === "")) {
              errorMessage.value = formatMessage(messages.ERR_0011);
              scrollToTop();
              return;
            }
            // 表示対象コードリストに設定
            PopupData.value.agCodeList = lines
              .filter((item) => item.trim() != "") // 空白行を除外
              .map((item) => item.replace(/^"(.*)"$/, "$1")); // 前後のダブルクォーテーションを削除
          };
          reader.readAsText(file);
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 表示対象のアップロード件数を返却します。
     */
    const getValueAgCodeUploadCnt = computed(() => {
      return (
        Intl.NumberFormat("en-US").format(PopupData.value.agCodeList.length) +
        "件"
      );
    });

    /**
     * 添付ファイルアップロードボタン押下時
     * @param trigger
     */
    const onContentsFileUpload = (trigger: string) => {
      // イベントの発火元を保存
      uploadTarget.value = trigger;

      // イベントの発火元により処理を分岐
      switch (trigger) {
        case LoginPopupRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          if (tempFileInput.value) {
            tempFileInput.value.click();
          }
          break;
        case LoginPopupRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          if (imgFileInput.value) {
            imgFileInput.value.click();
          }
          break;
      }
    };

    /**
     * 添付ファイル選択時
     * @param event
     */
    const handleContentsFileSelected = (event: Event) => {
      contentsFileSelected(event, uploadTarget.value);
    };

    /**
     * 添付ファイル選択時
     * @param event
     * @param trigger
     */
    const contentsFileSelected = (event: Event, trigger: string) => {
      if (processingStore.isProcessing) {
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;
      errorMessage.value = "";

      const fileInput = event.target as HTMLInputElement;
      const file = fileInput.files?.[0];

      try {
        if (file) {
          const contentsFile = {
            rowNo: getContentsFileMaxRowNo(trigger) + 1,
            fileName: file.name,
            file: file,
            fileUrl: null,
            isUpload: true,
          };

          // ファイルサイズチェック
          if (!isFileSize(contentsFile.file)) {
            errorMessage.value = formatMessage(
              messages.ERR_0024,
              maxFileSize / (1024 * 1024)
            );
            scrollToTop();
            return;
          }

          let messageId = "";
          let arg = "";

          // イベントの発火元により処理を分岐
          switch (trigger) {
            case LoginPopupRegConstants.TRIGGER_TEMP_FILE:
              // 添付ファイル

              if (!isFileExtensions(contentsFile.file, ...tempFileExtensions)) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "添付ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  PopupData.value.contentsTempFileList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "添付ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "添付ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              PopupData.value.contentsTempFileList.push(contentsFile);
              break;
            case LoginPopupRegConstants.TRIGGER_IMG_FILE:
              // 画像ファイル

              if (!isFileExtensions(contentsFile.file, ...imgFileExtensions)) {
                // 拡張子チェック
                messageId = messages.ERR_0027;
                arg = "画像ファイル";
              } else if (
                !isFilenameDuplicate(
                  contentsFile,
                  PopupData.value.contentsImgList
                )
              ) {
                // ファイル名重複チェック
                messageId = messages.ERR_0017;
                arg = "画像ファイル名";
              } else if (!checkFileName(file.name.toLowerCase())) {
                // ファイル名チェック
                messageId = messages.ERR_0025;
                arg = "画像ファイル名";
              }

              // エラーがある場合
              if (messageId) {
                errorMessage.value = formatMessage(messageId, arg);
                scrollToTop();
                return;
              }

              PopupData.value.contentsImgList.push(contentsFile);
              break;
          }
        }
      } finally {
        // ファイルを未選択状態にする
        fileInput.value = "";
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * コンテンツファイルの最大値の行番号を返却します。
     */
    const getContentsFileMaxRowNo = (trigger: string): number => {
      let contentsFileList: ContentsFile[] = [];
      switch (trigger) {
        case LoginPopupRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          contentsFileList = PopupData.value.contentsTempFileList;
          break;

        case LoginPopupRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          contentsFileList = PopupData.value.contentsImgList;
          break;
      }

      if (contentsFileList.length < 1) {
        return 0;
      }
      return Math.max.apply(
        null,
        contentsFileList.map(function (contentsFile) {
          return contentsFile.rowNo;
        })
      );
    };

    /**
     * コンテンツファイル削除
     * @param rowNo 行番号
     * @param trigger イベント発火元
     */
    const onRemoveContentsFile = (rowNo: number, trigger: string) => {
      switch (trigger) {
        case LoginPopupRegConstants.TRIGGER_TEMP_FILE:
          // 添付ファイル
          PopupData.value.contentsTempFileList =
            PopupData.value.contentsTempFileList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          // 添付ファイルが0件の場合
          if (!hasContentsTempFile.value) {
            // 添付ファイル説明クリア
            PopupData.value.contentsTempFileExp = "";
          }
          break;
        case LoginPopupRegConstants.TRIGGER_IMG_FILE:
          // 画像ファイル
          PopupData.value.contentsImgList =
            PopupData.value.contentsImgList.filter(
              (contentsFile) => contentsFile.rowNo != rowNo
            );
          // 画像ファイルが0件の場合
          if (!hasContentsImgFile.value) {
            // 画像ファイル説明クリア
            PopupData.value.contentsImgFileExp = "";
          }
          break;
      }
    };

    /**
     * 日付が有効な場合は日付、無効な場合はnullを返却します。
     */
    const getValidStrDate = (strDate: string): string | null => {
      if (strDate) {
        return strDate;
      }
      return null;
    };

    /**
     * サーバー日付をフォーマットします。
     */
    const formatDate = (strDate: string): string => {
      if (strDate) {
        return format(strDate, "yyyy-MM-dd");
      }
      return "";
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
      scrollToTop();
    };

    /**
     * 編集モードUPDATE判定
     */
    const isEditModeUpdate = computed(() => {
      return processingMode.value == AppConstants.LOGIN_POPUP_EDIT_MODE_UPDATE;
    });

    /**
     * 表示対象ALL判定
     */
    const isHyojiTaishoAll = computed(() => {
      return (
        PopupData.value.hyojiTaisho == LoginPopupRegConstants.HYOJI_TAISHO_ALL
      );
    });

    /**
     * 表示対象AG_SEGMENT判定
     */
    const isHyojiTaishoAgSegment = computed(() => {
      return (
        PopupData.value.hyojiTaisho ==
        LoginPopupRegConstants.HYOJI_TAISHO_AG_SEGMENT
      );
    });

    /**
     * 表示対象AG_CODE判定
     */
    const isHyojiTaishoAgCode = computed(() => {
      return (
        PopupData.value.hyojiTaisho ==
        LoginPopupRegConstants.HYOJI_TAISHO_AG_CODE
      );
    });

    /**
     * コンテンツ画像ファイルアップロード判定
     */
    const hasContentsTempFile = computed(() => {
      return PopupData.value.contentsTempFileList.length > 0;
    });

    /**
     * コンテンツ添付ファイルアップロード判定
     */
    const hasContentsImgFile = computed(() => {
      return PopupData.value.contentsImgList.length > 0;
    });

    return {
      isInitError,
      errorMessage,
      isEditModeUpdate,
      contentsCategoryName,
      PopupData,
      AppConstants,
      handleContentUpdate,
      isHyojiTaishoAgSegment,
      agSegmentList,
      LoginPopupRegConstants,
      onChangeHyojiTaisho,
      isHyojiTaishoAgCode,
      onAgCodeFileUpload,
      getValueAgCodeUploadCnt,
      handleAgCodeFileUpload,
      hasContentsTempFile,
      onRemoveContentsFile,
      handleContentsFileSelected,
      onContentsFileUpload,
      hasContentsImgFile,
      onBack,
      onFixed,
      isFilenameDuplicate,
      isFileSize,
      hyojiTaishoExtensions,
      tempFileExtensions,
      imgFileExtensions,
      isHyojiTaishoAll,
      uploadProgress,
      txtDispDtFrom,
      agCodeFileInput,
      isInitComplete,
      tempFileInput,
      imgFileInput,
    };
  },
});
</script>
<style scoped>
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 143px;
}
fieldset {
  border: 2px solid #ccc;
  padding: 10px;
  margin: 10px 0;
}
legend {
  font-weight: bold;
  padding: 0 10px;
  float: initial;
  width: initial;
  margin-bottom: initial;
  font-size: initial;
  line-height: initial;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
.form-control {
  display: inline-block;
  vertical-align: middle;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
input[type="date"] {
  width: auto;
}
table {
  border-collapse: separate;
  width: 100%;
}
.form-check-input[name="hyojiTaisho"] {
  margin: 0rem 0.2rem 0rem 0rem;
  vertical-align: inherit;
}
.form-check-input[name="checkPatarn"] {
  margin: 0rem 0.2rem -0.1rem 0rem;
  vertical-align: inherit;
}
.form-check-input[name="checkDispTarget"] {
  margin: 0rem 0.2rem -0.1rem 0rem;
  vertical-align: inherit;
}
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
td .btn-sm {
  width: 25px;
}
.file-upload {
  display: inline-block;
}
.vertical-align-top {
  vertical-align: top;
}

.checklabel {
  margin: 0 1rem 1rem 1rem;
}
</style>

<style>
.ql-editor .color-ql-0_0_0 {
  color: rgb(0, 0, 0);
}

.ql-editor .color-ql-255_0_0 {
  color: rgb(255, 0, 0);
}

.ql-editor .color-ql-0_0_255 {
  color: rgb(0, 0, 255);
}

.ql-editor .color-ql-255_255_0 {
  color: rgb(255, 255, 0);
}

.ql-editor .color-ql-0_128_0 {
  color: rgb(0, 128, 0);
}

.ql-editor .color-ql-128_0_128 {
  color: rgb(128, 0, 128);
}
</style>
